import Sortable from 'sortablejs';
import { getState, modifyState } from '~src/state';
// import { updatePageNumbers } from '~src/multipages';

export const makePagesDraggable = () => {
  // const currentPageIndex = getState('currentPageIndex');
  const sortableList = document.getElementById('editor-sidebar-pages');

  new Sortable(sortableList, {
    animation: 500,
    revertOnSpill: true,
    ghostClass: 'editor-dragged-page-area',
    onEnd: function (event) {
      // TODO: [DEV-461] Drag & Drop pages sorting handler
      const { oldIndex, newIndex } = event;
      // const isDraggedPageSelected = currentPageIndex === oldIndex;

      // if (
      //   (currentPageIndex === newIndex || currentPageIndex == oldIndex) &&
      //   oldIndex < newIndex
      // ) {
      //   modifyState('currentPageIndex', newIndex);
      // }

      // if (
      //   (currentPageIndex === newIndex || currentPageIndex == oldIndex) &&
      //   newIndex < oldIndex
      // ) {
      //   modifyState('currentPageIndex', oldIndex);
      // }

      // change page order and PUT!!!
      if (oldIndex !== newIndex) {
        const swappedOld = { ...getState('pages')[oldIndex] };
        const swappedNew = { ...getState('pages')[newIndex] };

        // swap pages
        modifyState(`pages[${oldIndex}]`, swappedNew);
        modifyState(`pages[${newIndex}]`, swappedOld);
        // await updatePageNumbers();
      }
    },
  });
};
